export default {
  SEARCH_CATALOG_ALLIANZ_PERIODICITY_OF_CONTRIBUTION_QUERY: Symbol.for('SEARCH_CATALOG_ALLIANZ_PERIODICITY_OF_CONTRIBUTION_QUERY'),
  CATALOG_ALLIANZ_PERIODICITY_OF_CONTRIBUTION_REPOSITORY: Symbol.for('CATALOG_ALLIANZ_PERIODICITY_OF_CONTRIBUTION_REPOSITORY'),
  CATALOG_ALLIANZ_PERIODICITY_OF_CONTRIBUTION_STATE_MANAGER: Symbol.for('CATALOG_ALLIANZ_PERIODICITY_OF_CONTRIBUTION_STATE_MANAGER'),
};
